export enum BlockPath {
    FoundationsCompanyName = "company-name",
    FoundationsBusinessSector = "business-sector",
    FoundationsProductType = "product-type",
    FoundationsProductCategory = "product-category",
    FoundationsMissionVisionInspiration = "mission-vision-inspiration",
    FoundationsFoundingStory = "founding-story",
    CustomerAudienceLocation = "audience-location",
    CustomerAudienceAge = "audience-age",
    CustomerAudienceDescription = "audience-description",
    CustomerAudienceInterests = "audience-interests",
    CustomerAudiencePriority = "audience-priority",
    CustomerAudienceSegments = "audience-segments",
    BrandMissionVision = "mission-vision",
    BrandBrandPositioning = "brand-positioning",
    BrandBrandTone = "brand-tone",
    BrandBrandExperiencePrinciples = "brand-experience-principles",
    BrandBrandIdentityInspiration = "brand-identity-inspiration",
    BrandBrandIdentity = "brand-identity",
    BrandValueProposition = "value-proposition",
    ProductProductList = "product-list",
    ProductProductFeatures = "product-features",
    ProductProductCaseStudies = "product-case-studies",
    ProductProductDiscount = "product-discount",
    ProductProductStrategy = "product-strategy",
    ProductProductRoadmap = "product-roadmap",
    MembershipMembershipModel = "membership-model",
    MembershipCommunityInspiration = "community-inspiration",
    MembershipCommunityStrategy = "community-strategy",
    MembershipMembershipStructure = "membership-structure",
    MembershipAcquisitionBenefits = "acquisition-benefits",
    MembershipMemberBenefitsChurn = "member-benefits-churn",
    MembershipMemberReferral = "member-referral",
    ExperienceCurrentPlatforms = "current-platforms",
    ExperienceUserOnboarding = "user-onboarding",
    ExperienceEmailTrigger = "email-trigger",
    ExperienceCustomerServiceApproach = "customer-service-approach",
    ExperienceCustomerService = "customer-service",
    ContentContentPositioning = "content-positioning",
    ContentContentPrinciples = "content-principles",
    ContentContentEditorial = "content-editorial",
    ContentContentMerchandising = "content-merchandising",
    ContentContentProduct = "content-product",
    ContentSocialChannels = "social-channels",
    ContentSocialStrategy = "social-strategy",
    ContentLeadMagnet = "lead-magnet",
    ContentNewsletterFormat = "newsletter-format",
    ContentSearchStrategy = "search-strategy",
    ContentCompetitorSearch = "competitor-search",
    CommsBusinessGoals = "business-goals",
    CommsMarketingGoal = "marketing-goal",
    CommsUserPainpoints = "user-painpoints",
    CommsBarrierAssessment = "barrier-assessment",
    CommsCommunicationGoals = "communication-goals",
    CommsKeyMessages = "key-messages",
    CommsSocialTactics = "social-tactics",
    CommsBrandTaglines = "brand-taglines",
    CommsSocialCampaignChannel = "social-campaign-channel",
    CommsSocialCampaignStrategy = "social-campaign-strategy",
    CommsMarketingBudget = "marketing-budget",
    CommsPaidAdvertising = "paid-advertising",
    CommsGoogleAd = "google-ad",
    OperationsBusinessStaffing = "business-staffing",
    OperationsContactDetails = "contact-details",
    OperationsOperationsFixedCosts = "operations-fixed-costs",
    OperationsOpsWorkflow1 = "ops-workflow1",
    OperationsOpsWorkflow2 = "ops-workflow2",
    OperationsOpsWorkflow3 = "ops-workflow3",
    OperationsCookiePolicy = "cookie-policy",
    OperationsPrivacyPolicy = "privacy-policy",
    GrowthYearGoals = "year-goals",
    GrowthCurrentSales = "current-sales",
    GrowthGrowthFiveYear = "growth-five-year",
    GrowthQuarterlyPlanning = "quarterly-planning",
    GrowthQuarterlyPromotion = "quarterly-promotion",
    SalesSalesPrinciples = "sales-principles",
    SalesOutboundEmailstrategy = "outbound-emailstrategy",
    SalesOutreachSalesstrategy = "outreach-salesstrategy",
    SalesAffiliateSales = "affiliate-sales",
    PartnershipsMembershipPartnerships = "membership-partnerships",
    PartnershipsPartnershipsCurrent = "partnerships-current",
    PartnershipsPartnershipsAffiliate = "partnerships-affiliate",
    HrHrJobdescription = "hr-jobdescription",
    HrHrProcess = "hr-process",
    SponsorshipsSponsorshipTypes = "sponsorship-types",
    SponsorshipsSponsorshipsPackages = "sponsorships-packages",
    SponsorshipsSponsorshipCurrent = "sponsorship-current",
    EventsEventsFacilities = "events-facilities",
    EventsEventsPackages = "events-packages",
    EventsEventsFood = "events-food",
    EventsEventsDrinks = "events-drinks",
    EventsEventsTravel = "events-travel",
    EventsEventsOperations = "events-operations",
    DesignerDesignerEthos = "designer-ethos",
    DesignerDesignerCapabilities = "designer-capabilities",
    DesignerDesignerProcess = "designer-process",
    DesignerDesignerProposal = "designer-proposal",
    EducationEducationType = "education-type",
    EducationEducationLevel = "education-level",
    EducationEducationClassess = "education-classess",
    EducationEducationFunding = "education-funding",
    EducationEducationFees = "education-fees",
    EducationEducationFacilities = "education-facilities",
    EducationEducationAlumni = "education-alumni",
    EducationEducationExtracurricular = "education-extracurricular",
    StartupStartupProblem = "startup-problem",
    StartupStartupFundraisingStatus = "startup-fundraising-status",
    StartupStartupLocations = "startup-locations",
    StartupStartupInvestorProfile = "startup-investor-profile",
    StartupStartupTamSamSom = "startup-tam-sam-som",
    StartupStartupElevatorPitch = "startup-elevator-pitch",
    StartupStartupPitchDeck = "startup-pitch-deck",
    StartupStartupInvestorUpdate = "startup-investor-update",
    StartupStartupCasestudy = "startup-casestudy",
    StartupStartupGrantAvailability = "startup-grant-availability",
    StartupStartupApidoc = "startup-apidoc",
    FarmFarmType = "farm-type",
    FarmFarmSize = "farm-size",
    FarmFarmEnvironmentalprograms = "farm-environmentalprograms",
    FarmCropTypes = "crop-types",
    FarmLivestockTypes = "livestock-types",
    FarmFarmProduce = "farm-produce",
    FarmFarmEquipment = "farm-equipment",
    FarmFarmCultivation = "farm-cultivation",
    FarmFarmProcesses = "farm-processes",
    FarmFarmFieldKnowledge = "farm-field-knowledge",
    EcommEcommShipping = "ecomm-shipping",
    EcommEcommReturnDetails = "ecomm-return-details",
    EcommEcommReturns = "ecomm-returns",
    TravelTravelLocations = "travel-locations",
    TravelTravelAvailability = "travel-availability",
    TravelTravelLocationtimes = "travel-locationtimes",
    TravelTravelReseller = "travel-reseller",
    ConsultingConsultingSpeciality = "consulting-speciality",
    ConsultingDiscoveryApproach = "discovery-approach",
    ConsultingConsultingProcess = "consulting-process",
    ConsultingConsultingProposal = "consulting-proposal",
    ConsultingConsultingHourlyRate = "consulting-hourly-rate",
    ArchitectArchitectureType = "architecture-type",
    ArchitectArchitectureConstruction = "architecture-construction",
    ArchitectArchitectureServices = "architecture-services",
    ArchitectArchitectureWork = "architecture-work",
    WineWineGrapes = "wine-grapes",
    WineWinePhilosophy = "wine-philosophy",
    WineWineVineyard = "wine-vineyard",
    WineWineTerroir = "wine-terroir",
    WineWineTour = "wine-tour",
    BeverageBeveragesTypes = "beverages-types",
    BeverageBeverageVarieties = "beverage-varieties",
    BeverageBeverageProduction = "beverage-production",
    BeverageBeverageTasting = "beverage-tasting",
    BeverageBeveragePremises = "beverage-premises",
    BeverageBeverageDistribution = "beverage-distribution",
    AccommodationAccommodationType = "accommodation-type",
    AccommodationAccommodationLocations = "accommodation-locations",
    AccommodationAccommodationDescription = "accommodation-description",
    AccommodationAccommodationPackages = "accommodation-packages",
    AccommodationAccommodationRules = "accommodation-rules",
    AccommodationAccommodationContact = "accommodation-contact",
    SelfStorageStorageType = "storage-type",
    SelfStorageStorageArea = "storage-area",
    SelfStorageStorageRules = "storage-rules",
    SelfStorageStorageRent = "storage-rent",
    SelfStorageStorageSecurity = "storage-security",
    SelfStorageStorageContact = "storage-contact",
    RestaurantRestaurantType = "restaurant-type",
    RestaurantRestaurantMenu = "restaurant-menu",
    RestaurantRestaurantSignatureDish = "restaurant-signature-dish",
    RestaurantRestaurantPriorityDish = "restaurant-priority-dish",
    RestaurantRestaurantCrossSell = "restaurant-cross-sell",
    RestaurantRestaurantMenuPackaging = "restaurant-menu-packaging",
    RealEstateRealEstateType = "real-estate-type",
    RealEstateRealEstateLocations = "real-estate-locations",
    RealEstateRealEstateComplaint = "real-estate-complaint",
    DentistDentistTypes = "dentist-types",
    DentistDentistTeam = "dentist-team",
    DoctorDoctorField = "doctor-field",
    DoctorDoctorTeam = "doctor-team",
    DoctorDoctorQualifications = "doctor-qualifications",
    DoctorDoctorInsurance = "doctor-insurance",
    CharityNonprofitType = "nonprofit-type",
    CharityNonprofitLocations = "nonprofit-locations",
    CharityNonprofitBeneficiary = "nonprofit-beneficiary",
    CharityNonprofitFundMix = "nonprofit-fund-mix",
    CharityNonprofitGrants = "nonprofit-grants",
    CharityNonprofitDonorTypes = "nonprofit-donor-types",
    CharityNonprofitTactics = "nonprofit-tactics",
    AgencyAgencyType = "agency-type",
    AgencyAgencyCapabilities = "agency-capabilities",
    AgencyAgencyProcess = "agency-process",
    AgencyAgencySpeciality = "agency-speciality",
    AgencyAgencyCasestudies = "agency-casestudies",
    AgencyAgencyAwards = "agency-awards",
    AgencyAgencySow = "agency-SOW",
    AgencyAgencyRates = "agency-rates",
    AgencyAgencyTestimonials = "agency-testimonials",
    AgencyAgencyLeads = "agency-leads",
    ConstructionConstructionTypes = "construction-types",
    ConstructionConstructionTeam = "construction-team",
    ConstructionConstructionOverhead = "construction-overhead",
    ConstructionConstructionOverheadVariable = "construction-overhead-variable",
    ConstructionConstructionBilling = "construction-billing",
    FundFundName = "fund-name",
    FundFundSize = "fund-size",
    FundFundThesis = "fund-thesis",
    FundFundStage = "fund-stage",
    FundFundDate = "fund-date",
    FundCheckSize = "check-size",
    ManufacturingManufacturingIndustries = "manufacturing-industries",
    ManufacturingManufacturingSubsidiary = "manufacturing-subsidiary",
    ManufacturingManufacturingProcess = "manufacturing-process",
    ManufacturingManufacturingMaterials = "manufacturing-materials",
    ManufacturingManufacturingSolutions = "manufacturing-solutions",
    CoachCoachType = "coach-type",
    CoachCoachQualifications = "coach-qualifications",
    CoachCoachPhilosophy = "coach-philosophy",
    CoachCoachCourse = "coach-course",
    CoachCoachMethod = "coach-method",
    CoachCoachTechniques = "coach-techniques",
    CoachCoachCaseStudies = "coach-case-studies",
    SportsTeamSportsTeamGround = "sports-team-ground",
    SportsTeamSportsTeamCoaching = "sports-team-coaching",
    SportsTeamSportsTeamPlayers = "sports-team-players",
    SportsTeamSportsTeamFeatures = "sports-team-features",
    SportsTeamSportsTeamSponsors = "sports-team-sponsors",
    PersonalTrainerExerciseTypes = "exercise-types",
    PersonalTrainerExerciseEquipment = "exercise-equipment",
    PersonalTrainerTrainingPhilosophy = "training-philosophy",
    PersonalTrainerDietPhilosophy = "diet-philosophy",
    PersonalTrainerProgramDesign = "program-design",
    PersonalTrainerSuccessStories = "success-stories",
    GymGymOpeningTimes = "gym-opening times",
    GymGymEquipment = "gym-equipment",
    GymGymClasses = "gym-classes",
    AthleteAthleteSport = "athlete-sport",
    AthleteAthleteSponsors = "athlete-sponsors",
    ClimbingGymClimbingLocations = "climbing-locations",
    ClimbingGymClimbingTypes = "climbing-types",
    ClimbingGymClimbingEthos = "climbing-ethos",
    ClimbingGymClimbingPasses = "climbing-passes",
    ClimbingGymClimbingTraining = "climbing-training",
    ClimbingGymClimbingClassess = "climbing-classess",
    ClimbingGymClimbingSafety = "climbing-safety",
    GolfClubGolfCourse = "golf-course",
    GolfClubGolfEthos = "golf-ethos",
    GolfClubGolfFacilities = "golf-facilities",
    GolfClubGolfCourseGuide = "golf-course-guide",
    GolfClubGolfCompetitions = "golf-competitions",
    GolfClubGolfTeams = "golf-teams",
    LandManagementLandSize = "land-size",
    LandManagementLandType = "land-type",
    LandManagementLandPurpose = "land-purpose",
    LandManagementLandGoals = "land-goals",
    LandManagementLandPolicies = "land-policies",
    LandManagementLandRental = "land-rental",
    LandManagementLandCapital = "land-capital",
    LandManagementOutlineAnyEnvironmentalStrategiesThatAreNecessaryForTheManagementOfTheLand = "Outline any environmental strategies that are necessary for the management of the land",
    LandManagementLandSocial = "land-social",
    LandManagementLandWildlife = "land-wildlife",
    LandManagementLandTeam = "land-team",
    RetailRetailPrinciples = "retail-principles",
    ResearchResearchMarket = "research-market",
    ResearchResearchConsumer = "research-consumer",
    ResearchResearchCompetitor = "research-competitor",
    BuildingManagementBuildingAlterationPolicy = "building-alteration-policy",
    BuildingManagementBuildingAlterationApplication = "building-alteration-application",
    BuildingManagementBuildingSubletGuide = "building-sublet-guide",
    BuildingManagementBuildingSubletRider = "building-sublet-rider",
    BuildingManagementBuildingSubletApplication = "building-sublet-application",
    BuildingManagementBuildingDecorationApplication = "building-decoration-application",
    BuildingManagementBuildingSalesPolicy = "building-sales-policy",
    BuildingManagementBuildingSalesApplication = "building-sales-application",
    BuildingManagementBuildingClosingInstructions = "building-closing-instructions",
    BuildingManagementBuildingHowGuide = "building-how-guide",
    BuildingManagementBuildingDuesPayments = "building-dues-payments",
    BuildingManagementBuildingMaintenance = "building-maintenance",
    BuildingManagementTrashManagement = "trash-management",
    BuildingManagementStorageWaivers = "storage-waivers",
    BuildingManagementBuildingMovingPolicy = "building-moving-policy",
    BuildingManagementBuildingHomeowners = "building-homeowners",
    BuildingManagementBuildingRefiProcess = "building-refi-process",
    BuildingManagementBuildingRefiPolicy = "building-refi-policy",
    BuildingManagementBuildingRefiApplication = "Building-refi-application",
    BuildingManagementBuildingTrustEstate = "building-trust-estate",
    BuildingManagementBuildingCertificateIncorporation = "building-certificate-incorporation",
    BuildingManagementBuildingDeclarationCondominium = "building-declaration-condominium",
    BuildingManagementBuildingOfferingPlan = "building-offering-plan",
    BuildingManagementBuildingSubscriptionAgreement = "building-subscription-agreement",
    BuildingManagementBuildingBylaws = "building-bylaws",
    BuildingManagementBuildingProprietaryLease = "building-proprietary-lease",
    BuildingManagementBuildingPlans = "building-plans",
    BuildingManagementBuildingHouseRules = "building-house-rules",
    LawyerLawyerServices = "lawyer-services",
    LawyerLawyerClients = "lawyer-clients"
}

export const blockPathDescriptions = {
    [BlockPath.FoundationsCompanyName]: "What is the name of the company, brand or project you are building?",
    [BlockPath.FoundationsBusinessSector]: "What category does your business fit into on, say, Linkedin?",
    [BlockPath.FoundationsProductType]: "Describe the type of products you sell in detail. List product categories. ",
    [BlockPath.FoundationsProductCategory]: "Describe how you sell your product. Is it physical goods? Is it a subscription or a service? Is it access to content? Do you sell them online or in person?",
    [BlockPath.FoundationsMissionVisionInspiration]: "What impact do you want to have on your users' lives, or the world at large?",
    [BlockPath.FoundationsFoundingStory]: "What's your company's origin story? What problem are you passionate about solving for your users? How did you spot the opportunity? The more detail, the better!",
    [BlockPath.CustomerAudienceLocation]: "Where are your target audience based? Describe the cities, countries and regions they may inhabit.",
    [BlockPath.CustomerAudienceAge]: "What age range are your target audience?",
    [BlockPath.CustomerAudienceDescription]: "Describe your audience in detail, work through who they are, what they do and what their interests and behaviors might be. ",
    [BlockPath.CustomerAudienceInterests]: "Defines the key interests and behaviors of your audience",
    [BlockPath.CustomerAudiencePriority]: "Every brand can define a group of people that is most valuable/lucrative as a user/customer. What's yours?",
    [BlockPath.CustomerAudienceSegments]: "Outlines the subgroups within your target audience",
    [BlockPath.BrandMissionVision]: "Statements that define your core purpose and core activities of the business, and an outline for the future you want to create.",
    [BlockPath.BrandBrandPositioning]: "The unique place your brand occupies in the minds of your target audience relative to your competitors.",
    [BlockPath.BrandBrandTone]: "Describe the tone of voice you want your brand to have, and how that's expressed in text, images and/or video",
    [BlockPath.BrandBrandExperiencePrinciples]: "Core tenets of how your brand will behave to deliver on the brand positioning for your audience",
    [BlockPath.BrandBrandIdentityInspiration]: "Describe how you would like your brand to look and feel",
    [BlockPath.BrandBrandIdentity]: "The way your brand manifests through the likes of fonts, photography style and colors",
    [BlockPath.BrandValueProposition]: "A concise statement that communicates the unique benefits and value your product, service, or brand offers to your customers.",
    [BlockPath.ProductProductList]: "Add a complete list of all your individual products. Revisit & adjust this as you add/remove products.",
    [BlockPath.ProductProductFeatures]: "Outline the key product features that are vital for your users and audience to know",
    [BlockPath.ProductProductCaseStudies]: "Add relevant case studies you want to use in your communications",
    [BlockPath.ProductProductDiscount]: "Add any relevant discount codes you might want to use in communications",
    [BlockPath.ProductProductStrategy]: "Outlines a product strategy for the evolution of your product",
    [BlockPath.ProductProductRoadmap]: "Defines a step-by-step approach to deliver on your product strategy",
    [BlockPath.MembershipMembershipModel]: "Describe any kind of membership model you use in your business strategy. Membership models include discount/loyalty programs, referral programs and more.",
    [BlockPath.MembershipCommunityInspiration]: "Describe the way you want your members to interact and engage as a group. Tell us about the tone of that community. ",
    [BlockPath.MembershipCommunityStrategy]: "An approach to engaging your audience outlining how your brand will drive engagement with them and between them.",
    [BlockPath.MembershipMembershipStructure]: "A structured approach to benefits for your membership",
    [BlockPath.MembershipAcquisitionBenefits]: "Specific benefits designed to drive sign up of your membership",
    [BlockPath.MembershipMemberBenefitsChurn]: "Specific benefits designed to reduce churn of members",
    [BlockPath.MembershipMemberReferral]: "How you can use your own members to drive referral",
    [BlockPath.ExperienceCurrentPlatforms]: "What are the current technology platforms you are using for your business?",
    [BlockPath.ExperienceUserOnboarding]: "Defines the onboarding plan for your users",
    [BlockPath.ExperienceEmailTrigger]: "Lists emails needed for key moments for your target users",
    [BlockPath.ExperienceCustomerServiceApproach]: "What capabilities do you have to manage customer service?",
    [BlockPath.ExperienceCustomerService]: "Outlines the customer service approach you can take with your capabilities",
    [BlockPath.ContentContentPositioning]: "Outlines the core principles for how your content comes to life for your audience",
    [BlockPath.ContentContentPrinciples]: "Content principles are rules to keep your messaging aligned & focused. Describe what you want included/excluded from your content.",
    [BlockPath.ContentContentEditorial]: "Ideas for content adjacent to your brand to drive awareness & relevance",
    [BlockPath.ContentContentMerchandising]: "Content ideas that drives users to your brand with the goal to convert",
    [BlockPath.ContentContentProduct]: "Outlines the key topics and headlines for content that delivers the value of your product",
    [BlockPath.ContentSocialChannels]: "What social channels are you using? How do you think about them?",
    [BlockPath.ContentSocialStrategy]: "Outlines your social strategy to reach and engage your target audience",
    [BlockPath.ContentLeadMagnet]: "Defines a way to entice potential leads to sign up for something of value from your brand",
    [BlockPath.ContentNewsletterFormat]: "Outlines the style of newsletter that will deliver on your goals and reflect your brand",
    [BlockPath.ContentSearchStrategy]: "Outlines key SEO strategy recommendations",
    [BlockPath.ContentCompetitorSearch]: "Defines a search strategy to differentiate from competitors",
    [BlockPath.CommsBusinessGoals]: "What are your business goals for the next quarter? (you can revisit this every few months)",
    [BlockPath.CommsMarketingGoal]: "Outlines the key goals you should aim to achieve with your advertising campaign",
    [BlockPath.CommsUserPainpoints]: "Defines a list of the key pain points for your target audience",
    [BlockPath.CommsBarrierAssessment]: "Defines barriers your brand faces in achieving its marketing goal and how to overcome them",
    [BlockPath.CommsCommunicationGoals]: "Outlines the goals for what your brand communications will need to convey to deliver your campaign",
    [BlockPath.CommsKeyMessages]: "Defines the key messages for your campaign",
    [BlockPath.CommsSocialTactics]: "Outlines social tactics that can be used as part of a campaign to deliver on your goals",
    [BlockPath.CommsBrandTaglines]: "Defines a selection of advertising taglines for your advertising campaign",
    [BlockPath.CommsSocialCampaignChannel]: "Choose a channel to develop a social campaign for",
    [BlockPath.CommsSocialCampaignStrategy]: "Defines a specific social campaign including strategy",
    [BlockPath.CommsMarketingBudget]: "What is your quarterly marketing budget?",
    [BlockPath.CommsPaidAdvertising]: "Outlines a paid media mix across different advertising channels ",
    [BlockPath.CommsGoogleAd]: "Defines a selection of Google Ad headlines, descriptions & search terms to use in your Google Ad campaign",
    [BlockPath.OperationsBusinessStaffing]: "List key staff members, include their role and area of responsibility. For larger groups, give us the headcount per area/division.",
    [BlockPath.OperationsContactDetails]: "Add the contact details, such as the main emails or addresses for your business",
    [BlockPath.OperationsOperationsFixedCosts]: "List your monthly fixed costs",
    [BlockPath.OperationsOpsWorkflow1]: "Outline a key workflow for your business that your employees will need to know",
    [BlockPath.OperationsOpsWorkflow2]: "Outline a key workflow for your business you will need your employees to know",
    [BlockPath.OperationsOpsWorkflow3]: "Outline a key workflow for your business you will need your employees to know",
    [BlockPath.OperationsCookiePolicy]: "Creates a draft cookie policy for you to review",
    [BlockPath.OperationsPrivacyPolicy]: "Creates a draft privacy policy for you to review",
    [BlockPath.GrowthYearGoals]: "What are your business goals for the next 12 months?",
    [BlockPath.GrowthCurrentSales]: "What are your current monthly sales?",
    [BlockPath.GrowthGrowthFiveYear]: "Outline your 5 year plan for the future of your business",
    [BlockPath.GrowthQuarterlyPlanning]: "A quarterly planning document to deliver on your business goals",
    [BlockPath.GrowthQuarterlyPromotion]: "Creates a list of promotions to deliver on your business goals",
    [BlockPath.SalesSalesPrinciples]: "Core principles for how your business approaches sales",
    [BlockPath.SalesOutboundEmailstrategy]: "A strategy for generating leads and sales with outbound email",
    [BlockPath.SalesOutreachSalesstrategy]: "A strategy to generate sales via active outreach across relevant channels",
    [BlockPath.SalesAffiliateSales]: "A strategy to develop affiliate sales via partners",
    [BlockPath.PartnershipsMembershipPartnerships]: "An approach to strategic partnerships with other brands to achieve your goals",
    [BlockPath.PartnershipsPartnershipsCurrent]: "List current partners and the details of the partnerships",
    [BlockPath.PartnershipsPartnershipsAffiliate]: "Add details of your affiliate program for use in communications",
    [BlockPath.HrHrJobdescription]: "Add the template format of your job description",
    [BlockPath.HrHrProcess]: "Add the structure of your ideal hiring process",
    [BlockPath.SponsorshipsSponsorshipTypes]: "Outline the type of sponsorships available",
    [BlockPath.SponsorshipsSponsorshipsPackages]: "Outline the complete sponsorship packages available",
    [BlockPath.SponsorshipsSponsorshipCurrent]: "List your sponsors for use in any communications",
    [BlockPath.EventsEventsFacilities]: "What facilities do you have on site?",
    [BlockPath.EventsEventsPackages]: "What packages do you offer for your events?",
    [BlockPath.EventsEventsFood]: "Describe the food options you offer",
    [BlockPath.EventsEventsDrinks]: "What bar and drinks do you offer? ",
    [BlockPath.EventsEventsTravel]: "What are the travel options to your events location, do you offer parking?",
    [BlockPath.EventsEventsOperations]: "Outline any key operational details, such as load in times, opening or arrival times",
    [BlockPath.DesignerDesignerEthos]: "What is your approach to design?",
    [BlockPath.DesignerDesignerCapabilities]: "What are your design capabilities for clients?",
    [BlockPath.DesignerDesignerProcess]: "Outline your design process you go undertake with clients",
    [BlockPath.DesignerDesignerProposal]: "Outline a proposal structure that you use regularly",
    [BlockPath.EducationEducationType]: "",
    [BlockPath.EducationEducationLevel]: "",
    [BlockPath.EducationEducationClassess]: "",
    [BlockPath.EducationEducationFunding]: "",
    [BlockPath.EducationEducationFees]: "",
    [BlockPath.EducationEducationFacilities]: "",
    [BlockPath.EducationEducationAlumni]: "",
    [BlockPath.EducationEducationExtracurricular]: "",
    [BlockPath.StartupStartupProblem]: "In one succinct line, describe the problem your startup is solving for users.",
    [BlockPath.StartupStartupFundraisingStatus]: "Are you currently raising funds? If so, at what stage/round, and from what kind of investor?",
    [BlockPath.StartupStartupLocations]: "Detail where you're incorporated and have operating entities",
    [BlockPath.StartupStartupInvestorProfile]: "To raise funds effectively you need to target investors that match your stage and sector. What does your ideal investor look like?",
    [BlockPath.StartupStartupTamSamSom]: "Banks and VCs will expect you to have a rough estimate of your Total Addressable Market (TAM), Serviceable Addressable Market (SAM), and Serviceable Obtainable Market (SOM)",
    [BlockPath.StartupStartupElevatorPitch]: undefined,
    [BlockPath.StartupStartupPitchDeck]: undefined,
    [BlockPath.StartupStartupInvestorUpdate]: "Investor Update",
    [BlockPath.StartupStartupCasestudy]: "Outline any case studies of your product that you might want to use in communications",
    [BlockPath.StartupStartupGrantAvailability]: "See what grants you might be able to take advantage of.",
    [BlockPath.StartupStartupApidoc]: "",
    [BlockPath.FarmFarmType]: "",
    [BlockPath.FarmFarmSize]: "",
    [BlockPath.FarmFarmEnvironmentalprograms]: "Add the environmental programs your farm is already enrolled in",
    [BlockPath.FarmCropTypes]: "",
    [BlockPath.FarmLivestockTypes]: "",
    [BlockPath.FarmFarmProduce]: "",
    [BlockPath.FarmFarmEquipment]: "List your main farming equipment",
    [BlockPath.FarmFarmCultivation]: "Cultivation Techniques you use on your farm",
    [BlockPath.FarmFarmProcesses]: "Add any specialist processes your farm use that you communicate to customers or partners",
    [BlockPath.FarmFarmFieldKnowledge]: "Add your knowledge about specific fields you might have",
    [BlockPath.EcommEcommShipping]: "",
    [BlockPath.EcommEcommReturnDetails]: "List specific return details, include any products that are non-returnable, conditions of products accepted and who is responsible for shipping costs",
    [BlockPath.EcommEcommReturns]: "Your policy for returns",
    [BlockPath.TravelTravelLocations]: "Add a list of all locations that your travel business has",
    [BlockPath.TravelTravelAvailability]: "What is your seasonality operation and open days",
    [BlockPath.TravelTravelLocationtimes]: "",
    [BlockPath.TravelTravelReseller]: "A strategy to sell your products via third parties such as OTAs",
    [BlockPath.ConsultingConsultingSpeciality]: "Outline any particular speciality areas your work covers",
    [BlockPath.ConsultingDiscoveryApproach]: "",
    [BlockPath.ConsultingConsultingProcess]: "The step by step process you use when running a consulting project",
    [BlockPath.ConsultingConsultingProposal]: "An example outline of your proposal structure",
    [BlockPath.ConsultingConsultingHourlyRate]: "What is the hourly rate that each staff member is billed at?",
    [BlockPath.ArchitectArchitectureType]: "List the type of building you do",
    [BlockPath.ArchitectArchitectureConstruction]: "Outline your construction approach",
    [BlockPath.ArchitectArchitectureServices]: "What services do you offer? ",
    [BlockPath.ArchitectArchitectureWork]: "Outline details of your past projects",
    [BlockPath.WineWineGrapes]: "",
    [BlockPath.WineWinePhilosophy]: "Outline your philosophy for winemaking",
    [BlockPath.WineWineVineyard]: "Describe your vineyards",
    [BlockPath.WineWineTerroir]: "Describe your unique terroir",
    [BlockPath.WineWineTour]: "Outline key details about your wine tours",
    [BlockPath.BeverageBeveragesTypes]: "List your drink types",
    [BlockPath.BeverageBeverageVarieties]: "Describe your grape varieties",
    [BlockPath.BeverageBeverageProduction]: "Outline your wine making processes",
    [BlockPath.BeverageBeverageTasting]: "Outline the tasting notes for your drinks",
    [BlockPath.BeverageBeveragePremises]: "Describe your premises and opening hours",
    [BlockPath.BeverageBeverageDistribution]: "Outline your distribution approach for your drinks",
    [BlockPath.AccommodationAccommodationType]: "Detail the type of accommodation",
    [BlockPath.AccommodationAccommodationLocations]: "List the addresses of your accommodation, include anything you may need in communications",
    [BlockPath.AccommodationAccommodationDescription]: "Write a detailed description of your accommodation, include any relevant features for your audience",
    [BlockPath.AccommodationAccommodationPackages]: "Outline any booking packages your accommodation has",
    [BlockPath.AccommodationAccommodationRules]: "List the rules for a stay at your accommodation",
    [BlockPath.AccommodationAccommodationContact]: "Include the contact details any guest will need during their stay",
    [BlockPath.SelfStorageStorageType]: "What kind of storage facility are you?",
    [BlockPath.SelfStorageStorageArea]: "What size storages do you offer?",
    [BlockPath.SelfStorageStorageRules]: "what you can and cannot store",
    [BlockPath.SelfStorageStorageRent]: "What lengths of storage rent do you offer?",
    [BlockPath.SelfStorageStorageSecurity]: "What type of security do you use at the facility?",
    [BlockPath.SelfStorageStorageContact]: "Add your location address and contact details",
    [BlockPath.RestaurantRestaurantType]: "Are you a dine-in-only restaurant? Do you offer takeout or delivery? Family or fine dining?",
    [BlockPath.RestaurantRestaurantMenu]: "List as many items from your menu as you can",
    [BlockPath.RestaurantRestaurantSignatureDish]: "List & describe any menu items you are known for or promote prominently",
    [BlockPath.RestaurantRestaurantPriorityDish]: "List any high-margin or high-priority menu items you are focused on increasing sales volume on",
    [BlockPath.RestaurantRestaurantCrossSell]: undefined,
    [BlockPath.RestaurantRestaurantMenuPackaging]: "Menu packaging",
    [BlockPath.RealEstateRealEstateType]: "",
    [BlockPath.RealEstateRealEstateLocations]: "Add a list of your building locations",
    [BlockPath.RealEstateRealEstateComplaint]: "A process for managing complaints from tenants",
    [BlockPath.DentistDentistTypes]: "",
    [BlockPath.DentistDentistTeam]: "List your team members and their qualifications",
    [BlockPath.DoctorDoctorField]: "Outline your medical speciality",
    [BlockPath.DoctorDoctorTeam]: "List the team in your practice",
    [BlockPath.DoctorDoctorQualifications]: "Outline the medical qualifications and experience of every team member",
    [BlockPath.DoctorDoctorInsurance]: "Outline the insurance your practice accepts",
    [BlockPath.CharityNonprofitType]: "What category does your nonprofit fall into?",
    [BlockPath.CharityNonprofitLocations]: "",
    [BlockPath.CharityNonprofitBeneficiary]: "What kind of beneficiary do funds raised by your organisation serve?",
    [BlockPath.CharityNonprofitFundMix]: "What are your current sources of funding?",
    [BlockPath.CharityNonprofitGrants]: undefined,
    [BlockPath.CharityNonprofitDonorTypes]: "Outlines key donor types that your organisation may consider targeting.",
    [BlockPath.CharityNonprofitTactics]: undefined,
    [BlockPath.AgencyAgencyType]: "Outline the type of work your agency undertakes",
    [BlockPath.AgencyAgencyCapabilities]: "Outline all the capabilities of your agency",
    [BlockPath.AgencyAgencyProcess]: "Outline your agency process from start to finished work for clients",
    [BlockPath.AgencyAgencySpeciality]: "Add any special processes you have, such as working with influencers, data or cultural impact.",
    [BlockPath.AgencyAgencyCasestudies]: "List key case studies of your agencies work ",
    [BlockPath.AgencyAgencyAwards]: "Outline any awards or client recognition your agency has received that you might want to use in communications",
    [BlockPath.AgencyAgencySow]: "An example SOW structure",
    [BlockPath.AgencyAgencyRates]: "Detail how you charge clients or the rates for your work",
    [BlockPath.AgencyAgencyTestimonials]: "Add any client testimonials you may want to use in communications",
    [BlockPath.AgencyAgencyLeads]: "Add your target clients details here for use in any emails or assistant conversation",
    [BlockPath.ConstructionConstructionTypes]: "Outline the key construction types you undertake",
    [BlockPath.ConstructionConstructionTeam]: "List your team members, their role and their relevant skillsets",
    [BlockPath.ConstructionConstructionOverhead]: "Add your monthly overhead costs",
    [BlockPath.ConstructionConstructionOverheadVariable]: "Add your variable monthly overhead costs",
    [BlockPath.ConstructionConstructionBilling]: "List your employees billable rates and include the discounted rate if daily",
    [BlockPath.FundFundName]: "What's the name of your active fund?",
    [BlockPath.FundFundSize]: "What's the total size of this fund? Specify your currency.",
    [BlockPath.FundFundThesis]: "Describe how your fund approaches investment, what sectors, technologies, geographies you invest in.",
    [BlockPath.FundFundStage]: "At what stage do you invest? Seed? Series A?",
    [BlockPath.FundFundDate]: "What month & year did this fund launch?",
    [BlockPath.FundCheckSize]: "Detail your typical investment size, or state a range",
    [BlockPath.ManufacturingManufacturingIndustries]: "List the industries your business supplies",
    [BlockPath.ManufacturingManufacturingSubsidiary]: "List your subsidiary product brands ",
    [BlockPath.ManufacturingManufacturingProcess]: "List any bespoke manufacturing processes that are communicated to customers",
    [BlockPath.ManufacturingManufacturingMaterials]: "List your key manufacturing materials used in your process and needed in any communications",
    [BlockPath.ManufacturingManufacturingSolutions]: "Outline the value your products deliver for clients in their end product",
    [BlockPath.CoachCoachType]: "Describe the type of coaching you deliver",
    [BlockPath.CoachCoachQualifications]: "",
    [BlockPath.CoachCoachPhilosophy]: "",
    [BlockPath.CoachCoachCourse]: "A structure for how you approach courses for your students",
    [BlockPath.CoachCoachMethod]: "Outline specific repeated coaching methods you use with your clients",
    [BlockPath.CoachCoachTechniques]: "",
    [BlockPath.CoachCoachCaseStudies]: "",
    [BlockPath.SportsTeamSportsTeamGround]: "Outline any details about your sporting ground, including location, seating size and facilities",
    [BlockPath.SportsTeamSportsTeamCoaching]: "Include details of your coaching staff and their areas of expertise",
    [BlockPath.SportsTeamSportsTeamPlayers]: "A list of your players",
    [BlockPath.SportsTeamSportsTeamFeatures]: "A list of your seasons fixtures",
    [BlockPath.SportsTeamSportsTeamSponsors]: "A list of your sponsors names and details for use in any communications",
    [BlockPath.PersonalTrainerExerciseTypes]: "Outline the type of workouts you use with clients",
    [BlockPath.PersonalTrainerExerciseEquipment]: "A list of the training equipment needed for your workouts",
    [BlockPath.PersonalTrainerTrainingPhilosophy]: "Describe how you think your clients should approach training",
    [BlockPath.PersonalTrainerDietPhilosophy]: "Outline your approach to managing diets",
    [BlockPath.PersonalTrainerProgramDesign]: "An example of how you like your programs to be designed ",
    [BlockPath.PersonalTrainerSuccessStories]: "Add your success stories and include quotes from your users",
    [BlockPath.GymGymOpeningTimes]: "",
    [BlockPath.GymGymEquipment]: "List the equipment available in your facility",
    [BlockPath.GymGymClasses]: "Outline any classes available to your members",
    [BlockPath.AthleteAthleteSport]: "",
    [BlockPath.AthleteAthleteSponsors]: "List any sponsors you have",
    [BlockPath.ClimbingGymClimbingLocations]: "List the locations, addresses and opening times of your climbing gyms",
    [BlockPath.ClimbingGymClimbingTypes]: "Outline the type of climbing available and the route types",
    [BlockPath.ClimbingGymClimbingEthos]: "What kind of ethos does your gym have?",
    [BlockPath.ClimbingGymClimbingPasses]: "List the passes and their pricing available to consumers",
    [BlockPath.ClimbingGymClimbingTraining]: "Outline the training equipment and facilities you have available",
    [BlockPath.ClimbingGymClimbingClassess]: "List any available classes and their details ",
    [BlockPath.ClimbingGymClimbingSafety]: "Outline any safety requirements someone must undertake to climb",
    [BlockPath.GolfClubGolfCourse]: "Outline your golf course type",
    [BlockPath.GolfClubGolfEthos]: "Outline the ethos of your golf club",
    [BlockPath.GolfClubGolfFacilities]: "Outline the type of facilities you have",
    [BlockPath.GolfClubGolfCourseGuide]: "Add a guide to your course",
    [BlockPath.GolfClubGolfCompetitions]: "Outline any upcoming competitions you are hosting",
    [BlockPath.GolfClubGolfTeams]: "Outline any teams your club has",
    [BlockPath.LandManagementLandSize]: "What is the size of your land in acres or hectares?",
    [BlockPath.LandManagementLandType]: "Outline the type of land you're managing",
    [BlockPath.LandManagementLandPurpose]: "Outline the strategic purpose of your land management",
    [BlockPath.LandManagementLandGoals]: "What are your strategic long term goals??",
    [BlockPath.LandManagementLandPolicies]: "Outline any legal policies which impact the management of the land",
    [BlockPath.LandManagementLandRental]: "Detail any current rental assets on the land",
    [BlockPath.LandManagementLandCapital]: "Detail your current strategy for development of the land",
    [BlockPath.LandManagementOutlineAnyEnvironmentalStrategiesThatAreNecessaryForTheManagementOfTheLand]: "",
    [BlockPath.LandManagementLandSocial]: "Detail any social strategy that you wish to implement on the land",
    [BlockPath.LandManagementLandWildlife]: "Outline any wildlife management practices you use",
    [BlockPath.LandManagementLandTeam]: "Add details of your teams capabilities",
    [BlockPath.RetailRetailPrinciples]: "Add your design principles for your retail stores",
    [BlockPath.ResearchResearchMarket]: "Add insights about your market",
    [BlockPath.ResearchResearchConsumer]: "Add insights about your consumer",
    [BlockPath.ResearchResearchCompetitor]: "Add insights about your competitors",
    [BlockPath.BuildingManagementBuildingAlterationPolicy]: "",
    [BlockPath.BuildingManagementBuildingAlterationApplication]: "",
    [BlockPath.BuildingManagementBuildingSubletGuide]: "",
    [BlockPath.BuildingManagementBuildingSubletRider]: "",
    [BlockPath.BuildingManagementBuildingSubletApplication]: "",
    [BlockPath.BuildingManagementBuildingDecorationApplication]: "",
    [BlockPath.BuildingManagementBuildingSalesPolicy]: "",
    [BlockPath.BuildingManagementBuildingSalesApplication]: "",
    [BlockPath.BuildingManagementBuildingClosingInstructions]: "",
    [BlockPath.BuildingManagementBuildingHowGuide]: "",
    [BlockPath.BuildingManagementBuildingDuesPayments]: "",
    [BlockPath.BuildingManagementBuildingMaintenance]: "",
    [BlockPath.BuildingManagementTrashManagement]: "",
    [BlockPath.BuildingManagementStorageWaivers]: "",
    [BlockPath.BuildingManagementBuildingMovingPolicy]: "",
    [BlockPath.BuildingManagementBuildingHomeowners]: "",
    [BlockPath.BuildingManagementBuildingRefiProcess]: "",
    [BlockPath.BuildingManagementBuildingRefiPolicy]: "",
    [BlockPath.BuildingManagementBuildingRefiApplication]: "",
    [BlockPath.BuildingManagementBuildingTrustEstate]: "",
    [BlockPath.BuildingManagementBuildingCertificateIncorporation]: "Legally forms the co-op as a corporation",
    [BlockPath.BuildingManagementBuildingDeclarationCondominium]: "Establishes the condo and defines units/common areas",
    [BlockPath.BuildingManagementBuildingOfferingPlan]: "Discloses all material facts to buyers",
    [BlockPath.BuildingManagementBuildingSubscriptionAgreement]: "Documents share ownership tied to a unit",
    [BlockPath.BuildingManagementBuildingBylaws]: "Governs board operations and voting rights",
    [BlockPath.BuildingManagementBuildingProprietaryLease]: "Grants occupancy rights to shareholders",
    [BlockPath.BuildingManagementBuildingPlans]: "Defines unit boundaries and layout",
    [BlockPath.BuildingManagementBuildingHouseRules]: "Regulates day-to-day conduct within the building",
    [BlockPath.LawyerLawyerServices]: "",
    [BlockPath.LawyerLawyerClients]: "List your clients",
    } as const
;
export const blockPathName = {
    [BlockPath.FoundationsCompanyName]: "Project Name",
    [BlockPath.FoundationsBusinessSector]: "Business Sector",
    [BlockPath.FoundationsProductType]: "Product Types",
    [BlockPath.FoundationsProductCategory]: "Monetization Model",
    [BlockPath.FoundationsMissionVisionInspiration]: "Business Impact",
    [BlockPath.FoundationsFoundingStory]: "Origin Story",
    [BlockPath.CustomerAudienceLocation]: "Audience Location",
    [BlockPath.CustomerAudienceAge]: "Audience Age",
    [BlockPath.CustomerAudienceDescription]: "Audience Description",
    [BlockPath.CustomerAudienceInterests]: "Audience Interests",
    [BlockPath.CustomerAudiencePriority]: "Ideal Customer",
    [BlockPath.CustomerAudienceSegments]: "Audience Segmentation",
    [BlockPath.BrandMissionVision]: "Mission & Vision",
    [BlockPath.BrandBrandPositioning]: "Brand Positioning",
    [BlockPath.BrandBrandTone]: "Brand Tone",
    [BlockPath.BrandBrandExperiencePrinciples]: "Brand Experience Principles",
    [BlockPath.BrandBrandIdentityInspiration]: "Look & Feel",
    [BlockPath.BrandBrandIdentity]: "Brand Identity",
    [BlockPath.BrandValueProposition]: "Value Proposition",
    [BlockPath.ProductProductList]: "Product List",
    [BlockPath.ProductProductFeatures]: "Key Product Feature Descriptions",
    [BlockPath.ProductProductCaseStudies]: "Case Studies",
    [BlockPath.ProductProductDiscount]: "Product Discount Codes",
    [BlockPath.ProductProductStrategy]: "Product Strategy",
    [BlockPath.ProductProductRoadmap]: "Product Roadmap",
    [BlockPath.MembershipMembershipModel]: "Subscription Or Membership Model",
    [BlockPath.MembershipCommunityInspiration]: "Community Inspiration",
    [BlockPath.MembershipCommunityStrategy]: "Community Strategy",
    [BlockPath.MembershipMembershipStructure]: "Membership Structure",
    [BlockPath.MembershipAcquisitionBenefits]: "Acquisition Benefits",
    [BlockPath.MembershipMemberBenefitsChurn]: "Churn Benefits",
    [BlockPath.MembershipMemberReferral]: "Member Referral",
    [BlockPath.ExperienceCurrentPlatforms]: "Technology Platforms",
    [BlockPath.ExperienceUserOnboarding]: "User Onboarding",
    [BlockPath.ExperienceEmailTrigger]: "Trigger email",
    [BlockPath.ExperienceCustomerServiceApproach]: "Customer Service Approach",
    [BlockPath.ExperienceCustomerService]: "Customer Service",
    [BlockPath.ContentContentPositioning]: "Content Positioning",
    [BlockPath.ContentContentPrinciples]: "Content Principles",
    [BlockPath.ContentContentEditorial]: "Editorial Content",
    [BlockPath.ContentContentMerchandising]: "Merchandising Content",
    [BlockPath.ContentContentProduct]: "Product Content",
    [BlockPath.ContentSocialChannels]: "Social Channels",
    [BlockPath.ContentSocialStrategy]: "Social Strategy",
    [BlockPath.ContentLeadMagnet]: "Lead Magnet",
    [BlockPath.ContentNewsletterFormat]: "Newsletter Format",
    [BlockPath.ContentSearchStrategy]: "Search Strategy",
    [BlockPath.ContentCompetitorSearch]: "Competitor Search Strategy",
    [BlockPath.CommsBusinessGoals]: "Next Quarter Goals",
    [BlockPath.CommsMarketingGoal]: "Marketing Goal",
    [BlockPath.CommsUserPainpoints]: "Audience Pain Points",
    [BlockPath.CommsBarrierAssessment]: "Barrier Assessment",
    [BlockPath.CommsCommunicationGoals]: "Communication Goals",
    [BlockPath.CommsKeyMessages]: "Key Messages",
    [BlockPath.CommsSocialTactics]: "Social Tactics",
    [BlockPath.CommsBrandTaglines]: "Taglines",
    [BlockPath.CommsSocialCampaignChannel]: "Social Campaign Channel",
    [BlockPath.CommsSocialCampaignStrategy]: "Social Campaign Strategy",
    [BlockPath.CommsMarketingBudget]: "Marketing Budget",
    [BlockPath.CommsPaidAdvertising]: "Paid Advertising",
    [BlockPath.CommsGoogleAd]: "Google Ads",
    [BlockPath.OperationsBusinessStaffing]: "Staffing",
    [BlockPath.OperationsContactDetails]: "Contact Details",
    [BlockPath.OperationsOperationsFixedCosts]: "Monthly Fixed Costs",
    [BlockPath.OperationsOpsWorkflow1]: "Company Workflow A",
    [BlockPath.OperationsOpsWorkflow2]: "Company Workflow B",
    [BlockPath.OperationsOpsWorkflow3]: "Company Workflow C",
    [BlockPath.OperationsCookiePolicy]: "Cookie Policy",
    [BlockPath.OperationsPrivacyPolicy]: "Privacy Policy",
    [BlockPath.GrowthYearGoals]: "12-Month Goals",
    [BlockPath.GrowthCurrentSales]: "Monthly Sales",
    [BlockPath.GrowthGrowthFiveYear]: "5 Year Plan",
    [BlockPath.GrowthQuarterlyPlanning]: "Quarterly Planning",
    [BlockPath.GrowthQuarterlyPromotion]: "Promotions",
    [BlockPath.SalesSalesPrinciples]: "Sales Principles",
    [BlockPath.SalesOutboundEmailstrategy]: "Outbound Emails Sales Strategy",
    [BlockPath.SalesOutreachSalesstrategy]: "Outreach Sales Strategy",
    [BlockPath.SalesAffiliateSales]: "Affiliate Sales Strategy",
    [BlockPath.PartnershipsMembershipPartnerships]: "Partnership Strategy",
    [BlockPath.PartnershipsPartnershipsCurrent]: "Partners",
    [BlockPath.PartnershipsPartnershipsAffiliate]: "Affiliate Program",
    [BlockPath.HrHrJobdescription]: "Job Description Format",
    [BlockPath.HrHrProcess]: "Hiring Process",
    [BlockPath.SponsorshipsSponsorshipTypes]: "Sponsorship Types",
    [BlockPath.SponsorshipsSponsorshipsPackages]: "Sponsorship Packages",
    [BlockPath.SponsorshipsSponsorshipCurrent]: "Current Sponsors",
    [BlockPath.EventsEventsFacilities]: "Facilities",
    [BlockPath.EventsEventsPackages]: "Packages",
    [BlockPath.EventsEventsFood]: "Food",
    [BlockPath.EventsEventsDrinks]: "Drinks",
    [BlockPath.EventsEventsTravel]: "Travel",
    [BlockPath.EventsEventsOperations]: "Operational Details",
    [BlockPath.DesignerDesignerEthos]: "Design Ethos",
    [BlockPath.DesignerDesignerCapabilities]: "Design Capabilities",
    [BlockPath.DesignerDesignerProcess]: "Design Process",
    [BlockPath.DesignerDesignerProposal]: "Proposal Structure",
    [BlockPath.EducationEducationType]: "Education Type",
    [BlockPath.EducationEducationLevel]: "Student Level",
    [BlockPath.EducationEducationClassess]: "Classess",
    [BlockPath.EducationEducationFunding]: "Funding Type",
    [BlockPath.EducationEducationFees]: "Tuition Fees",
    [BlockPath.EducationEducationFacilities]: "Facilities",
    [BlockPath.EducationEducationAlumni]: "Alumni Testinomials",
    [BlockPath.EducationEducationExtracurricular]: "Extracurricular Activities",
    [BlockPath.StartupStartupProblem]: "What Problem Do You Solve?",
    [BlockPath.StartupStartupFundraisingStatus]: "Fundraising Status",
    [BlockPath.StartupStartupLocations]: "Locations",
    [BlockPath.StartupStartupInvestorProfile]: "Investor target profile",
    [BlockPath.StartupStartupTamSamSom]: "TAM/SAM/SOM",
    [BlockPath.StartupStartupElevatorPitch]: "Elevator Pitch",
    [BlockPath.StartupStartupPitchDeck]: "Pitch Deck Structure",
    [BlockPath.StartupStartupInvestorUpdate]: "Investor Update",
    [BlockPath.StartupStartupCasestudy]: "Case Studies",
    [BlockPath.StartupStartupGrantAvailability]: "Grant Availability",
    [BlockPath.StartupStartupApidoc]: "API Documentation",
    [BlockPath.FarmFarmType]: "Farm Type",
    [BlockPath.FarmFarmSize]: "Farm Size & Field Number",
    [BlockPath.FarmFarmEnvironmentalprograms]: "Environmental Programs",
    [BlockPath.FarmCropTypes]: "Crop Types",
    [BlockPath.FarmLivestockTypes]: "Livestock Types",
    [BlockPath.FarmFarmProduce]: "Produce",
    [BlockPath.FarmFarmEquipment]: "Farm Equipment",
    [BlockPath.FarmFarmCultivation]: "Cultivation Techniques",
    [BlockPath.FarmFarmProcesses]: "Specialist Processes",
    [BlockPath.FarmFarmFieldKnowledge]: "Field Knowledge",
    [BlockPath.EcommEcommShipping]: "Shipping Location",
    [BlockPath.EcommEcommReturnDetails]: "Return Details",
    [BlockPath.EcommEcommReturns]: "Returns Policy",
    [BlockPath.TravelTravelLocations]: "Locations",
    [BlockPath.TravelTravelAvailability]: "Availability",
    [BlockPath.TravelTravelLocationtimes]: "Location Open Times",
    [BlockPath.TravelTravelReseller]: "3rd Party Reseller Strategy",
    [BlockPath.ConsultingConsultingSpeciality]: "Expertise Speciality Areas",
    [BlockPath.ConsultingDiscoveryApproach]: "Discovery Approach",
    [BlockPath.ConsultingConsultingProcess]: "Consulting Process",
    [BlockPath.ConsultingConsultingProposal]: "Proposal Structure",
    [BlockPath.ConsultingConsultingHourlyRate]: "Staffing Hourly Rate",
    [BlockPath.ArchitectArchitectureType]: "Building Types",
    [BlockPath.ArchitectArchitectureConstruction]: "Construction Approach",
    [BlockPath.ArchitectArchitectureServices]: "Services",
    [BlockPath.ArchitectArchitectureWork]: "Past Work",
    [BlockPath.WineWineGrapes]: "Grape Varietals",
    [BlockPath.WineWinePhilosophy]: "Winemaking Philosophy",
    [BlockPath.WineWineVineyard]: "Vineyard Details",
    [BlockPath.WineWineTerroir]: "Terroir",
    [BlockPath.WineWineTour]: "Wine Tours",
    [BlockPath.BeverageBeveragesTypes]: "Beverage Types",
    [BlockPath.BeverageBeverageVarieties]: "Ingredients",
    [BlockPath.BeverageBeverageProduction]: "Production Processes",
    [BlockPath.BeverageBeverageTasting]: "Tasting Notes",
    [BlockPath.BeverageBeveragePremises]: "Premises Details",
    [BlockPath.BeverageBeverageDistribution]: "Distribution Approach",
    [BlockPath.AccommodationAccommodationType]: "Accommodation Type",
    [BlockPath.AccommodationAccommodationLocations]: "Accommodation Locations",
    [BlockPath.AccommodationAccommodationDescription]: "Accommodation Description",
    [BlockPath.AccommodationAccommodationPackages]: "Accommodation Packages",
    [BlockPath.AccommodationAccommodationRules]: "Accommodation Rules",
    [BlockPath.AccommodationAccommodationContact]: "Contact Details",
    [BlockPath.SelfStorageStorageType]: "Storage type",
    [BlockPath.SelfStorageStorageArea]: "Area Size",
    [BlockPath.SelfStorageStorageRules]: "Storage Rules",
    [BlockPath.SelfStorageStorageRent]: "Storage Rent",
    [BlockPath.SelfStorageStorageSecurity]: "Storage Security",
    [BlockPath.SelfStorageStorageContact]: "Contact Details",
    [BlockPath.RestaurantRestaurantType]: "Restaurant type",
    [BlockPath.RestaurantRestaurantMenu]: "Menu",
    [BlockPath.RestaurantRestaurantSignatureDish]: "Signature dishes",
    [BlockPath.RestaurantRestaurantPriorityDish]: "Priority menu items",
    [BlockPath.RestaurantRestaurantCrossSell]: "Cross-selling strategy",
    [BlockPath.RestaurantRestaurantMenuPackaging]: "",
    [BlockPath.RealEstateRealEstateType]: "Building Type",
    [BlockPath.RealEstateRealEstateLocations]: "Building Locations",
    [BlockPath.RealEstateRealEstateComplaint]: "Complaints Process",
    [BlockPath.DentistDentistTypes]: "Dentistry Types",
    [BlockPath.DentistDentistTeam]: "Team Qualifications",
    [BlockPath.DoctorDoctorField]: "Medical Field",
    [BlockPath.DoctorDoctorTeam]: "Team",
    [BlockPath.DoctorDoctorQualifications]: "Qualifications",
    [BlockPath.DoctorDoctorInsurance]: "Insurance",
    [BlockPath.CharityNonprofitType]: "Nonprofit type",
    [BlockPath.CharityNonprofitLocations]: "Your locations",
    [BlockPath.CharityNonprofitBeneficiary]: "Beneficiary type",
    [BlockPath.CharityNonprofitFundMix]: "Current funding mix",
    [BlockPath.CharityNonprofitGrants]: "Grant Availability",
    [BlockPath.CharityNonprofitDonorTypes]: "Donor types",
    [BlockPath.CharityNonprofitTactics]: "Fundraising Tactics",
    [BlockPath.AgencyAgencyType]: "Agency Type",
    [BlockPath.AgencyAgencyCapabilities]: "Agency Capabilities",
    [BlockPath.AgencyAgencyProcess]: "Agency Process",
    [BlockPath.AgencyAgencySpeciality]: "Speciality Process",
    [BlockPath.AgencyAgencyCasestudies]: "Agency Case Studies",
    [BlockPath.AgencyAgencyAwards]: "Agency Recognition",
    [BlockPath.AgencyAgencySow]: "Example SOW",
    [BlockPath.AgencyAgencyRates]: "Remuneration Approach",
    [BlockPath.AgencyAgencyTestimonials]: "Client Testimonials",
    [BlockPath.AgencyAgencyLeads]: "Target Clients",
    [BlockPath.ConstructionConstructionTypes]: "Construction Types",
    [BlockPath.ConstructionConstructionTeam]: "Construction Team",
    [BlockPath.ConstructionConstructionOverhead]: "Fixed Overhead Costs",
    [BlockPath.ConstructionConstructionOverheadVariable]: "Variable Overhead Costs",
    [BlockPath.ConstructionConstructionBilling]: "Hourly Billing",
    [BlockPath.FundFundName]: "Fund Name",
    [BlockPath.FundFundSize]: "Fund Size",
    [BlockPath.FundFundThesis]: "Investment Thesis",
    [BlockPath.FundFundStage]: "Investment stage",
    [BlockPath.FundFundDate]: "Fund Launch Date",
    [BlockPath.FundCheckSize]: "Check Size",
    [BlockPath.ManufacturingManufacturingIndustries]: "Industries",
    [BlockPath.ManufacturingManufacturingSubsidiary]: "Subsidiary Brands",
    [BlockPath.ManufacturingManufacturingProcess]: "Manufacturing Process",
    [BlockPath.ManufacturingManufacturingMaterials]: "Material Types",
    [BlockPath.ManufacturingManufacturingSolutions]: "Solutions",
    [BlockPath.CoachCoachType]: "Coaching Type",
    [BlockPath.CoachCoachQualifications]: "Coaching Qualifications",
    [BlockPath.CoachCoachPhilosophy]: "Coaching Philosophy",
    [BlockPath.CoachCoachCourse]: "Course Structure",
    [BlockPath.CoachCoachMethod]: "Coaching Methods",
    [BlockPath.CoachCoachTechniques]: "Specific Techniques",
    [BlockPath.CoachCoachCaseStudies]: "Case Studies",
    [BlockPath.SportsTeamSportsTeamGround]: "Ground Details",
    [BlockPath.SportsTeamSportsTeamCoaching]: "Coaching Staff",
    [BlockPath.SportsTeamSportsTeamPlayers]: "Players",
    [BlockPath.SportsTeamSportsTeamFeatures]: "Fixtures",
    [BlockPath.SportsTeamSportsTeamSponsors]: "Sponsors",
    [BlockPath.PersonalTrainerExerciseTypes]: "Training Type",
    [BlockPath.PersonalTrainerExerciseEquipment]: "Training Equipment",
    [BlockPath.PersonalTrainerTrainingPhilosophy]: "Training Philosophy",
    [BlockPath.PersonalTrainerDietPhilosophy]: "Diet-Philosophy",
    [BlockPath.PersonalTrainerProgramDesign]: "Program Design",
    [BlockPath.PersonalTrainerSuccessStories]: "Success Stories",
    [BlockPath.GymGymOpeningTimes]: "Opening Times",
    [BlockPath.GymGymEquipment]: "Equipment",
    [BlockPath.GymGymClasses]: "Classes",
    [BlockPath.AthleteAthleteSport]: "Sport",
    [BlockPath.AthleteAthleteSponsors]: "Sponsors",
    [BlockPath.ClimbingGymClimbingLocations]: "Locations & Opening Times",
    [BlockPath.ClimbingGymClimbingTypes]: "Climbing Type",
    [BlockPath.ClimbingGymClimbingEthos]: "Climbing Gym Ethos",
    [BlockPath.ClimbingGymClimbingPasses]: "Passess",
    [BlockPath.ClimbingGymClimbingTraining]: "Training facilities",
    [BlockPath.ClimbingGymClimbingClassess]: "Classess",
    [BlockPath.ClimbingGymClimbingSafety]: "Safety Requirements",
    [BlockPath.GolfClubGolfCourse]: "Course Type",
    [BlockPath.GolfClubGolfEthos]: "Club Ethos",
    [BlockPath.GolfClubGolfFacilities]: "Facilities",
    [BlockPath.GolfClubGolfCourseGuide]: "Course Guide",
    [BlockPath.GolfClubGolfCompetitions]: "Competitions",
    [BlockPath.GolfClubGolfTeams]: "Teams",
    [BlockPath.LandManagementLandSize]: "Land Size",
    [BlockPath.LandManagementLandType]: "Land Type",
    [BlockPath.LandManagementLandPurpose]: "Strategic Purpose",
    [BlockPath.LandManagementLandGoals]: "Strategic Goals",
    [BlockPath.LandManagementLandPolicies]: "Land Policies",
    [BlockPath.LandManagementLandRental]: "Rental Strategy",
    [BlockPath.LandManagementLandCapital]: "Capital Strategy",
    [BlockPath.LandManagementOutlineAnyEnvironmentalStrategiesThatAreNecessaryForTheManagementOfTheLand]: "Environmental Strategy",
    [BlockPath.LandManagementLandSocial]: "Social Strategy",
    [BlockPath.LandManagementLandWildlife]: "Wildlife Management",
    [BlockPath.LandManagementLandTeam]: "Team",
    [BlockPath.RetailRetailPrinciples]: "Store Design Principles",
    [BlockPath.ResearchResearchMarket]: "Market Insights",
    [BlockPath.ResearchResearchConsumer]: "Consumer Insights",
    [BlockPath.ResearchResearchCompetitor]: "Competitor Insights",
    [BlockPath.BuildingManagementBuildingAlterationPolicy]: "Alteration Policy",
    [BlockPath.BuildingManagementBuildingAlterationApplication]: "Alteration Application",
    [BlockPath.BuildingManagementBuildingSubletGuide]: "Subleasing you apartment guide",
    [BlockPath.BuildingManagementBuildingSubletRider]: "Sublet Lease Rider",
    [BlockPath.BuildingManagementBuildingSubletApplication]: "Sublet Application",
    [BlockPath.BuildingManagementBuildingDecorationApplication]: "Decoration Application",
    [BlockPath.BuildingManagementBuildingSalesPolicy]: "Sales Policy",
    [BlockPath.BuildingManagementBuildingSalesApplication]: "Sales Application",
    [BlockPath.BuildingManagementBuildingClosingInstructions]: "Closing Instructions Documents",
    [BlockPath.BuildingManagementBuildingHowGuide]: "How to live in the building",
    [BlockPath.BuildingManagementBuildingDuesPayments]: "Dues Payments",
    [BlockPath.BuildingManagementBuildingMaintenance]: "Maintenance Requests",
    [BlockPath.BuildingManagementTrashManagement]: "Trash Management",
    [BlockPath.BuildingManagementStorageWaivers]: "Storage & Bike Waivers",
    [BlockPath.BuildingManagementBuildingMovingPolicy]: "Move In & Out Policy",
    [BlockPath.BuildingManagementBuildingHomeowners]: "Homeowners Insurance",
    [BlockPath.BuildingManagementBuildingRefiProcess]: "Refi Process Doc",
    [BlockPath.BuildingManagementBuildingRefiPolicy]: "Refi Policy",
    [BlockPath.BuildingManagementBuildingRefiApplication]: "Refi Application",
    [BlockPath.BuildingManagementBuildingTrustEstate]: "Trust & Estates",
    [BlockPath.BuildingManagementBuildingCertificateIncorporation]: "Certificate of Incorporation",
    [BlockPath.BuildingManagementBuildingDeclarationCondominium]: "Declaration of Condominium",
    [BlockPath.BuildingManagementBuildingOfferingPlan]: "Offering Plan",
    [BlockPath.BuildingManagementBuildingSubscriptionAgreement]: "Subscription Agreement",
    [BlockPath.BuildingManagementBuildingBylaws]: "Bylaws",
    [BlockPath.BuildingManagementBuildingProprietaryLease]: "Proprietary Lease",
    [BlockPath.BuildingManagementBuildingPlans]: "Condominium Map/Floor Plans",
    [BlockPath.BuildingManagementBuildingHouseRules]: "House Rules",
    [BlockPath.LawyerLawyerServices]: "Services",
    [BlockPath.LawyerLawyerClients]: "Representative Clients",
    } as const
;
